// removed by extract-text-webpack-plugin
module.exports = {"BackDrop":"backdrop__BackDrop__35XRS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/backdrop/backdrop.css
// module id = 147
// module chunks = 8